import * as actions from './auth.actions'

const initialState = {
  error: null,
  token: null,
  userInfo: null,
}

const actionsMap = {
  [actions.LOGIN_FINISH_SUCCESS]: (state, action) => {
    const token = action.data

    return {
      ...state,
      error: null,
      token,
    }
  },
  [actions.LOGIN_FINISH_ERROR]: (state, action) => {
    const error = action.data

    return {
      ...state,
      error,
      token: null,
    }
  },
  [actions.USER_INFO_FINISH_SUCCESS]: (state, action) => {
    const userInfo = action.data
    return {
      ...state,
      userInfo,
    }
  },
}

/* eslint require-jsdoc: 0 */
export function reducer(state = initialState, action = {}) {
  const fn = actionsMap[action.type]
  return fn ? fn(state, action) : state
}
